"use strict";
import { popupRegistry } from "components/Popups/registry";
import { PopupType } from "components/Popups/types";
import useIsWindowVisible from "hooks/useIsWindowVisible";
import { useCallback, useEffect, useRef } from "react";
const POLL_INTERVAL_MS = 5 * 60 * 1e3;
const VERSION_URL = "/build-version.json";
const POPUP_KEY = "new-version-available";
const CURRENT_COMMIT = process.env.REACT_APP_GIT_COMMIT_HASH;
export function NewVersionUpdater() {
  const windowVisible = useIsWindowVisible();
  const notifiedRef = useRef(false);
  const checkVersion = useCallback(async () => {
    if (notifiedRef.current || !CURRENT_COMMIT || CURRENT_COMMIT === "unknown") {
      return;
    }
    try {
      const response = await fetch(`${VERSION_URL}?t=${Date.now()}`, { cache: "no-store" });
      if (!response.ok) {
        return;
      }
      const data = await response.json();
      const deployedCommit = data.commit;
      if (deployedCommit && deployedCommit !== "unknown" && deployedCommit !== CURRENT_COMMIT) {
        notifiedRef.current = true;
        popupRegistry.addPopup({ type: PopupType.NewVersion }, POPUP_KEY, Infinity);
      }
    } catch {
    }
  }, []);
  useEffect(() => {
    if (!windowVisible) {
      return void 0;
    }
    checkVersion();
    const interval = setInterval(checkVersion, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [windowVisible, checkVersion]);
  return null;
}
